import axios from "axios";
import groups from "../../models/permisosDeAcceso/groups";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getGroups(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/dcapermisogrupos/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return groups.fromJson(item);
        });
      });
  }

  new(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      permisoId: items.permisoId,
      fecDesde: items.fecDesde + "T00:00:00.000Z",
      fecHasta:
        items.fecHasta === null ? undefined : items.fecHasta + "T00:00:00.000Z",
      segmId: items.segmId,
      segmDespl: items.segmDespl,
      grps: items.grps,
    };
    return axios.post(`${url}/dcapermisogrupos`, payload, { headers });
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      fecDesde: data.fecDesde + "T00:00:00.000Z",
      fecHasta:
        data.fecHasta === null ? undefined : data.fecHasta + "T00:00:00.000Z",
      segmId: data.segmId,
      segmDespl: data.segmDespl,
      haNoEx: data.fecHasta == null ? true : false,
    };

    return axios
      .patch(
        `${url}/dcapermisogrupos/${data.id}&${data.permisoId}&${data.fecDesdeOld}`,
        payload,
        { headers }
      )
      .then(() => {});
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/dcapermisogrupos/${data.id}&${data.permissionId}&${data.from}`,
      { headers }
    );
  }
}
export default service;
